import BaseApi from './base';
import { getImpersonationParams } from '@/util';

const setHeader = (params = {}) => ({
  ...params,
  headers: {
    type: 'PORTAL'
  }
});

const getHomeDetails = (jobId: string) => BaseApi.get(`buyer/job/${jobId}`, { params: getImpersonationParams() });

const getAppointments = (jobId: string) => BaseApi.get(`buyer/appointment/${jobId}`, { params: getImpersonationParams() });

const getCustomerCareRepData = (empId: string) => BaseApi.get(`teammember/customerCare/${empId}`, setHeader({ params: getImpersonationParams() }));

export { getHomeDetails, getAppointments, getCustomerCareRepData };
